import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/BeratungPlanungMontage/4.webp";
import { Grid } from "@material-ui/core";

export default function Inspektion() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Inspektion – lehnen Sie sich zurück" />
          <QList
            items={[
              "Organisation und Durchführung der regelmäßigen Regal- und Leiterprüfungen",
              "Transparente Dokumentation aller Inspektions- & Prüfungsleistungen",
              "Herstellerunabhängige Ersatzteilbeschaffung",
              "Durchführung sämtlicher Reparaturarbeiten",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
